import { filestackPath } from 'lib/helpers/utility';

import { withErrorBoundary } from 'components/shared/Error/Boundary';

import LazyImage from '../LazyImage/LazyImage';

import { IMAGE_VARIANTS } from './lib/getVariant';

const FilestackImage = (props) => {
  const {
    variant = 'square',
    size = '100%',
    position = 'center',
    alt = 'LazyImage',
    isRoundedSmooth = false
  } = props;

  const aspectRatio = IMAGE_VARIANTS[variant] || 1;

  const height =
    typeof size === 'string' && size.includes('%')
      ? `calc(${size} / ${aspectRatio})`
      : `${parseInt(size, 10) / aspectRatio}px`;

  const imageUrl = filestackPath(JSON.parse(props.src).jpg);

  return (
    <LazyImage
      {...props}
      src={imageUrl}
      width={size}
      height={height}
      position={position}
      alt={alt}
      isRoundedSmooth={isRoundedSmooth}
    />
  );
};

/**
 * @type {import('react').ForwardRefExoticComponent<import('./lib/propTypes').FilestackImageProps & import('react').RefAttributes<HTMLElement>>}
 */

export default withErrorBoundary(FilestackImage);
